'use client';

import { SessionProvider, signOut, useSession } from 'next-auth/react';
import { ReactNode, useEffect } from 'react';

function SessionErrorWatcher() {
  const { data: session } = useSession();
  useEffect(() => {
    if ((session as any)?.error === 'RefreshTokenExpired') {
      signOut({ callbackUrl: '/auth/login' });
    }
  }, [session]);
  return null;
}

export default function AuthContextProvider({
  children,
}: {
  children: ReactNode;
}) {
  return (
    <SessionProvider>
      <SessionErrorWatcher />
      {children}
    </SessionProvider>
  );
}
